import { render, staticRenderFns } from "./CourseTimetable.vue?vue&type=template&id=01e719bd&scoped=true"
import script from "./CourseTimetable.vue?vue&type=script&lang=ts"
export * from "./CourseTimetable.vue?vue&type=script&lang=ts"
import style0 from "./CourseTimetable.vue?vue&type=style&index=0&id=01e719bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e719bd",
  null
  
)

export default component.exports